/**
 * =====================================================
 * form-checkout.js
 * =====================================================
 *
 * Progetto: Ventura Shop
 * Tipo: Satellite JS
 * Dipendenza: main.js (namespace globale "ventura")
 *
 * Descrizione:
 * Questo file contiene tutte le logiche JS specifiche
 * per la pagina Checkout. Si integra con il namespace
 * globale "ventura" definito in main.js.
 *
 * Note:
 * - Non dipendere da altri satelliti, solo da main.js
 * - Il caricamento condizionale avviene tramite la
 *   variabile globale `isTemplate` passata da PHP
 *   tramite WP_PARAMS.is_page_template.
 * - Tutte le funzioni dovrebbero essere incapsulate
 *   all'interno di ventura o di closure locali.
 *
 * Esempio di utilizzo:
 *   ventura.cartInit();
 *
 * =====================================================
 */
const ventura = window.ventura;
window.isTemplate = window.WP_PARAMS ? window.WP_PARAMS.is_page_template : null;

(function($) {

    if (typeof isTemplate === 'undefined' || isTemplate !== 'templ-checkout.php') return;

    ventura.FormCheckout = {

        /**
         * Gestisce la validazione della lunghezza e i contatori visivi.
         */
        limitFields: {
            config: [
                { 'billing_first_name_field': 17 },
                { 'billing_last_name_field': 18 },
                { 'billing_address_1_field': 32 },
                { 'billing_address_2_field': 8 },
                { 'billing_city_field': 30 },
                { 'shipping_city_field': 30 },
                { 'shipping_first_name_field': 17 },
                { 'shipping_last_name_field': 18 },
                { 'shipping_address_1_field': 32 },
                { 'shipping_address_2_field': 8 },
                { 'billing_company_field': 32 },
                { 'shipping_company_field': 32 }
            ],

            init: function ($context = $(document)) {
                const self = this;
                $.each(this.config, function () {
                    $.each(this, function (id, maxLength) {
                        const $row = $('#' + id);
                        const $input = $row.find('input');
                        if ($input.length === 0) return;

                        // Reset e Setup attributi
                        $input.removeAttr('maxlength autocomplete')
                              .attr('maxlength', maxLength)
                              .attr('data-length', true);

                        self._renderCounter($row, $input, maxLength);

                        // Listener evento
                        $input.off('keyup').on('keyup', function () {
                            self._renderCounter($row, $(this), maxLength);
                        });
                    });
                });
            },

            // Aggiornare il contatore e l'errore
            _renderCounter: function ($row, $input, maxLength) {
                let $counter = $row.find('.input-counter');
                if ($counter.length === 0) {
                    $counter = $('<span class="input-counter"></span>').appendTo($row);
                }

                const remaining = maxLength - $input.val().length;

                if (remaining < 0) {
                    $counter.addClass('input-counter-error').html('testo troppo lungo');
                    $row.addClass('woocommerce-invalid-character-length');
                } else {
                    $counter.removeClass('input-counter-error').html(`${remaining} caratteri rimanenti`);
                    $row.removeClass('woocommerce-invalid-character-length');
                }
            }
        },

        /**
         * Gestisce la visibilità dei campi B2B e comportamenti correlati.
         */
        typeSwitcher: {
            init: function () {
                const self = this;
                const $container = $(document.body);

                const updateUI = () => {
                    const isAzienda = $('.checkbox-azienda input:checked').val() === 'azienda';
                    isAzienda ? self._applyAzienda() : self._applyPrivato();
                };

                updateUI();
                $container.on('change', '.checkbox-azienda input', updateUI);
                $container.on('updated_checkout', updateUI);
            },

            _applyAzienda: function () {
                $('.woocommerce-form-coupon-toggle, .create-account').hide();
                $('.js-tipo-azienda').show();
                $('.create-account input').prop('checked', true);

                if (!$(document.body).hasClass('logged-in')) {
                    const msg = "Dopo l'acquisto, verrà inviata una password al tuo indirizzo e-mail per accedere al tuo account.";
                    if ($('.b2b-create-account').length === 0) {
                        $('#billing_privacy_field').before(`<p class="form-row wide b2b-create-account">${msg}</p>`);
                    } else {
                        $('.b2b-create-account').show();
                    }
                }

                // Forza la spunta su "Crea account"
                const $createAccCheckbox = $('.create-account input[type="checkbox"]');
                if ($createAccCheckbox.length) {
                    $createAccCheckbox.prop('checked', true).trigger('change');
                }

                // Nasconde coupon (opzionale, se richiesto dal business)
                $('.woocommerce-form-coupon-toggle').hide();
            },

            _applyPrivato: function () {
                $('.create-account, .woocommerce-form-coupon-toggle').show();
                $('.js-tipo-azienda, .b2b-create-account').hide();
                // Reset campi B2B
                $('input[name="billing_pec"], input[name="billing_vat_number"], input[name="billing_company"], input[name="billing_codice_fiscale"]').val('');
            }
        },

        /**
         * Mappa il campo "fake" sul modulo coupon originale di WooCommerce
         */
        coupons: {
            init: function() {
                $(document).on('click', 'button[name="fake_apply_coupon"]', function(e) {
                    e.preventDefault();
                    e.stopImmediatePropagation();

                    const value = $('input#fake_coupon_code').val().trim().toUpperCase();
                    const $realForm = $('form.woocommerce-form-coupon');

                    // Validazione: PARTITAIVA15 solo per clienti B2B
                    // Verifica se il checkout è presente (se no, la validazione avverrà lato server)
                    if (value === 'PARTITAIVA15') {
                        const $checkbox = $('.checkbox-azienda input:checked');
                        
                        // Se il selector esiste (siamo al checkout), verifichiamo il valore
                        if ($checkbox.length > 0) {
                            const isB2B = $checkbox.val() === 'azienda';
                            
                            if (!isB2B) {
                                alert('Il coupon PARTITAIVA15 è riservato solo ai clienti con Partita IVA.');
                                $('input#fake_coupon_code').val('').focus();
                                return;
                            }
                        }
                        // Se il selector non esiste (siamo nel carrello), lasciamo procedere
                        // La validazione avverrà lato server via woocommerce_coupon_is_valid
                    }

                    if ($realForm.length && value) {
                        const $realInput = $realForm.find('input#coupon_code');
                        if ($realInput.length) {
                            $realInput.val(value);
                            $realForm.trigger('submit');
                        }
                    } else if (value) {
                        console.warn("Modulo coupon originale non trovato.");
                    }
                });
            }
        },

        helpers: {
            // Assicura che il pulsante PayPal sia visibile
            fixPaypalButton: function () {
                const toggle = () => {
                    // Selettori
                    const paypalInput = $('#payment_method_ppcp-gateway');
                    const orderButton = $('button[name="woocommerce_checkout_place_order"]');

                    // Se PayPal è selezionato, forziamo la visibilità del pulsante originale
                    if (paypalInput.is(':checked')) {
                        orderButton.removeClass('ppcp-hidden').show();
                    }
                };

                // 1. Eseguiamo un controllo a intervalli per i primi 5 secondi (per battere i caricamenti AJAX)
                let attempts = 0;
                const checkInterval = setInterval(() => {
                    toggle();
                    attempts++;
                    if (attempts > 20) clearInterval(checkInterval); // Si ferma dopo 5 secondi (250ms * 20)
                }, 250);

                // 2. Continuiamo a monitorare i cambiamenti manuali dell'utente
                $(document).on('updated_checkout change', 'input[name="payment_method"]', toggle);
            },
            // Forza il toggle del pulsante ordine in base ai termini
            bindPrivacyTerms: function () {
                const toggle = () => $('#place_order').prop('disabled', !$('#terms').is(':checked'));
                toggle();
                $(document).on('change', '#terms', toggle);
            }
        },

        /**
        * Monitora il riquadro dell'ordine e aggiorna eventuali totali esterni (es. in sidebar)
        */
        priceSync: {
            init: function() {
                const targetNode = document.getElementById('order_review');
                if (!targetNode) return;

                const observer = new MutationObserver(() => {
                    // Preleva il totale aggiornato da WooCommerce
                    const $amountEl = $('#order_review .order-total .amount, #order_review .product-total .amount').first();
                    if ($amountEl.length) {
                        const totalPrice = $amountEl.text();
                        // Aggiorna l'elemento della tua UI (es. barra fissa o sidebar)
                        $('.fixed-cart-total .amount').html(totalPrice);
                    }
                });

                observer.observe(targetNode, { childList: true, subtree: true });
            }
        },

        /**
        * Gestisce Regex, Campi Obbligatori e Controllo Email Ajax
        */
        validation: {
            patterns: {
                email: /^((([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.?$/i,
                phone: /^[0-9+ ]*$/ // Permette numeri, spazio e il simbolo +
            },

            init: function() {
                const self = this;
                const $form = $('form.checkout');

                // Intercettiamo l'invio dell'ordine
                $form.on('checkout_place_order', function() {
                    // Se la validazione fallisce, blocchiamo l'ordine (return false)
                    return self._validateAll();
                });
            },

            _validateAll: function() {
                let isValid = true;
                const email = $('#billing_email').val();
                const phone = $('#billing_phone').val();

                // Reset errori grafici precedenti
                $('.woocommerce-invalid').removeClass('woocommerce-invalid');

                // 1. Validazione Regex Email
                if (email && !this.patterns.email.test(email)) {
                    $('#billing_email_field').addClass('woocommerce-invalid');
                    isValid = false;
                }

                // 2. Validazione Regex Telefono
                if (phone && !this.patterns.phone.test(phone)) {
                    $('#billing_phone_field').addClass('woocommerce-invalid');
                    isValid = false;
                }

                // 3. Controllo Utente Esistente (Ajax sincrono o bloccante)
                if (isValid && !$('body').hasClass('logged-in') && email) {
                    // Nota: In un flusso "place_order" l'Ajax dovrebbe essere gestito con cautela.
                    // Se l'email esiste, apriamo il login e blocchiamo l'ordine.
                    this._checkUserAjax(email);
                }

                if (!isValid) {
                    $('html, body').animate({ scrollTop: $('.woocommerce-invalid:first').offset().top - 100 }, 500);
                }

                return isValid;
            },

            _checkUserAjax: function(email) {
                $.post(WP_PARAMS.ajax_url, {
                    action: 'existing_user',
                    email: email
                }, function(data) {
                    if (data.emailExists) {
                        $('.open-account-overlay').click(); // Trigger per il tuo popup di login
                        $('#username').val(email);
                        alert("Questo indirizzo email è già registrato. Effettua il login per procedere.");
                    }
                });
            }
        }
    };

    $(document).on('venturaReady', function() {
        ventura.FormCheckout.limitFields.init($('#customer_details'));
        ventura.FormCheckout.typeSwitcher.init();
        ventura.FormCheckout.helpers.fixPaypalButton();
        ventura.FormCheckout.helpers.bindPrivacyTerms();
        ventura.FormCheckout.priceSync.init();
        ventura.FormCheckout.validation.init();
        ventura.FormCheckout.coupons.init();
    });

})(jQuery);
